export default function genererMaterielsContrat(bail, materielsOfBail, materielsInBase) {
  const materielsCodes = [...new Set(materielsOfBail.map(m => m.codeMateriel))];
  materielsCodes.forEach(codeMateriel => {
    const materielReference = materielsInBase.find(mat => mat.code
      === codeMateriel);
    bail.contratsMateriels.push({
      materiel: materielReference,
      materielId: materielReference.id,
      isNew: true,
      logo: null,
    });
  });
}
